module.exports = __webpack_public_path__ + "faq/img/class.05669dc1.png";